<div class="vsr">

	<!-- setup bar -->
	<div class="vsr-setupbar">
		<span class="vsr-loading-pill" *ngIf="loadingConfig"><span class="vsr-spinner"></span> Checking setup</span>
		<span class="vsr-setup-warn" *ngIf="configLoaded && !configExists">This vendor isn't configured for statement reconciliation yet.</span>
		<button type="button" class="btn btn-outline-secondary btn-sm" (click)="showSetup = !showSetup">
			<mat-icon>settings</mat-icon> {{ showSetup ? 'Close setup' : (configExists ? 'Vendor setup' : 'Set up vendor') }}
		</button>
	</div>

	<!-- config editor -->
	<div class="vsr-card vsr-setup" *ngIf="showSetup">
		<div class="vsr-card__title">Vendor reconciliation setup — {{ supplierno }}</div>
		<div class="vsr-setup-grid">
			<label>Vendor label <input type="text" [(ngModel)]="cfg.vendor_label"></label>
			<label>Parser profile
				<select [(ngModel)]="cfg.parser_profile">
					<option value="">— choose —</option>
					<option value="tirehub_v1">tirehub_v1</option>
					<option value="atd_v1">atd_v1</option>
					<option value="usaf_v1">usaf_v1</option>
					<option value="vans_v1">vans_v1</option>
					<option value="gallagher_v1">gallagher_v1</option>
				</select>
			</label>
			<label>Terms code <input type="text" [(ngModel)]="cfg.terms_code" placeholder="N90, 2N10…"></label>
			<label class="vsr-chk"><input type="checkbox" [(ngModel)]="cfg.active"> Active</label>
		</div>

		<div class="vsr-setup-sub">Reference matching</div>
		<div class="vsr-setup-grid">
			<label>Ref prefixes (comma) <input type="text" [(ngModel)]="cfg.prefixes" placeholder="IN"></label>
			<label>Suffix variants (comma) <input type="text" [(ngModel)]="cfg.suffix_variants" placeholder="V, S"></label>
			<label class="vsr-chk"><input type="checkbox" [(ngModel)]="cfg.allow_raw"> Match raw invoice #</label>
		</div>

		<div class="vsr-setup-sub">Terms &amp; bucketing</div>
		<div class="vsr-setup-grid">
			<label>Due = invoice month +<input type="number" [(ngModel)]="cfg.terms_months" min="0" max="6"> months</label>
			<label>on day <input type="number" [(ngModel)]="cfg.terms_day" min="1" max="28"></label>
			<label>Bucket by
				<select [(ngModel)]="cfg.bucket_by">
					<option value="due_date">due date</option>
					<option value="age_code">age code</option>
				</select>
			</label>
			<label class="vsr-chk" *ngIf="cfg.bucket_by==='due_date'"><input type="checkbox" [(ngModel)]="cfg.credits_into_current"> Net credits into Current</label>
			<label>V8 cutover date <input type="date" [(ngModel)]="cfg.start_date"></label>
		</div>
		<div class="vsr-reason">Statement lines dated before the cutover predate V8 — they stay on the run and in the statement total, but sit in their own bucket, out of "amount due now" and out of Issues. They are carried, not written off: if the vendor is still billing them, that balance belongs in V8 as a one-time opening entry, not as line-by-line bookings. Leave blank for no cutover.</div>

		<div class="vsr-setup-sub">Allowed auto-fixes</div>
		<div class="vsr-setup-grid">
			<label class="vsr-chk"><input type="checkbox" [(ngModel)]="cfg.sf_due_date"> Due-date fix</label>
			<label class="vsr-chk"><input type="checkbox" [(ngModel)]="cfg.sf_ref"> Reference fix</label>
			<label class="vsr-chk"><input type="checkbox" [(ngModel)]="cfg.sf_reopen"> Reopen (owner)</label>
		</div>

		<div class="vsr-setup-sub">Workbook tab labels</div>
		<div class="vsr-setup-grid">
			<label>Raw tab <input type="text" [(ngModel)]="cfg.raw_tab"></label>
			<label>Issues tab <input type="text" [(ngModel)]="cfg.issues_tab"></label>
			<label>Ledger tab <input type="text" [(ngModel)]="cfg.ledger_tab"></label>
		</div>

		<div class="vsr-actions" style="margin-top:14px">
			<button class="btn btn-primary" [disabled]="savingConfig || !cfg.parser_profile" (click)="saveConfig()">
				{{ savingConfig ? 'Saving…' : 'Save vendor config' }}
			</button>
			<span class="vsr-reason" *ngIf="!cfg.parser_profile">Choose a parser profile to save.</span>
		</div>
	</div>

	<!-- New reconciliation -->
	<div class="vsr-card">
		<div class="vsr-card__title">Reconcile a statement</div>
		<div class="vsr-form">
			<label>Statement date <input type="date" [(ngModel)]="statementDate"></label>
			<label>Due date * <input type="date" [(ngModel)]="dueDate" required [class.vsr-req]="!dueDate"></label>
			<label>Account # <input type="text" [(ngModel)]="accountRef" placeholder="vendor acct"></label>
		</div>
		<ngx-dropzone class="vsr-dropzone" [class.vsr-dropzone--has]="fileName" [multiple]="false" [expandable]="true"
			accept="application/pdf,.pdf" (change)="onDropzoneChange($event)" [disabled]="running">
			<ngx-dropzone-label>
				<div class="vsr-dz">
					<mat-icon class="vsr-dz__icon">{{ fileName ? 'picture_as_pdf' : 'cloud_upload' }}</mat-icon>
					<span class="vsr-dz__title">{{ fileName || 'Drop statement PDF here, or click to choose' }}</span>
					<span class="vsr-dz__hint" *ngIf="!fileName">One PDF — {{ vendor?.suppname || 'the vendor' }} statement</span>
				</div>
			</ngx-dropzone-label>
		</ngx-dropzone>
		<div class="vsr-actions">
			<button type="button" class="btn btn-outline-secondary btn-sm" *ngIf="fileName" (click)="clearFile()">
				<mat-icon>close</mat-icon> Clear
			</button>
			<button class="btn btn-primary" [disabled]="running || !fileName || !dueDate" (click)="runRecon()"
				[matTooltip]="!dueDate ? 'Enter the due date first — it sets the pay cutoff' : ''">
				<mat-icon *ngIf="!running">play_arrow</mat-icon>
				{{ running ? 'Running…' : 'Run reconciliation' }}
			</button>
		</div>
		<div class="vsr-loading-line" *ngIf="loadingRuns || loadingRun">
			<span class="vsr-spinner"></span> {{ loadingRun ? 'Opening recent reconciliation…' : 'Loading reconciliation history…' }}
		</div>
		<div class="vsr-runs" *ngIf="runsList?.length">
			<span class="vsr-runs__lbl">Recent:</span>
			<span class="vsr-runchip" *ngFor="let r of runsList" [class.is-active]="run?.id===r.id">
				<button class="vsr-chip" [class.is-active]="run?.id===r.id" (click)="loadRun(r.id)">
					#{{ r.id }} · {{ r.statement_date }} · {{ r.total_lines }} lines
				</button>
				<button type="button" class="vsr-runchip__remove" title="Remove from Recent" (click)="archiveRun(r, $event)">×</button>
			</span>
		</div>
	</div>

	<ng-container *ngIf="run">
		<!-- sub-tabs -->
		<div class="vsr-tabs">
			<button [class.is-active]="subTab==='summary'" (click)="subTab='summary'">Summary</button>
			<button [class.is-active]="subTab==='issues'" (click)="subTab='issues'; loadLines(null)">Issues &amp; actions <span>({{ totalIssueCount() }})</span></button>
			<button [class.is-active]="subTab==='raw'" (click)="subTab='raw'; loadLines(null)">Raw statement <span *ngIf="run">({{ run.total_lines || 0 }})</span></button>
			<button [class.is-active]="subTab==='payables' && !payablesReviewOnly" (click)="subTab='payables'; payablesReviewOnly=false">V8 Payables <span>({{ payables?.length || 0 }})</span></button>
			<button [class.is-active]="subTab==='payables' && payablesReviewOnly" (click)="subTab='payables'; payablesReviewOnly=true">
				In V8, not on statement <span *ngIf="matchback">({{ matchback.review_count || 0 }})</span>
			</button>
			<button [class.is-active]="subTab==='ready'" (click)="enterReadyTab()">
				Ready to pay <span>({{ readyRows().length }})</span>
			</button>
			<span class="vsr-exportgrp">
				<button class="vsr-export" [disabled]="rescanning" (click)="rescan()" matTooltip="Re-match this run against current V8 data — no need to re-upload the PDF">
					<mat-icon>sync</mat-icon> {{ rescanning ? 'Rescanning…' : 'Rescan' }}
				</button>
				<button class="vsr-export" [disabled]="exporting" (click)="exportWorkbook(false)">
					<mat-icon>grid_on</mat-icon> XLSX
				</button>
				<button class="vsr-export" [disabled]="exporting" (click)="exportWorkbook(true)">
					<mat-icon>grid_on</mat-icon> Tab
				</button>
				<button class="vsr-export vsr-export--pdf" [disabled]="exportingPdf" (click)="exportPdf(false)">
					<mat-icon>picture_as_pdf</mat-icon> PDF
				</button>
				<button class="vsr-export vsr-export--pdf" [disabled]="exportingPdf" (click)="exportPdf(true)">
					<mat-icon>picture_as_pdf</mat-icon> Tab
				</button>
			</span>
		</div>

		<!-- SUMMARY -->
		<div class="vsr-card" *ngIf="subTab==='summary'">
			<div class="vsr-loading-line" *ngIf="loadingIssues || loadingFixes">
				<span class="vsr-spinner"></span> Loading summary details…
			</div>
			<div class="vsr-kpis">
				<div class="vsr-kpi"><span>Statement total</span><b>{{ run.parsed_total | currency }}</b></div>
				<div class="vsr-kpi"><span>Amount due now</span><b>{{ run.amount_due_now | currency }}</b></div>
				<div class="vsr-kpi" *ngIf="run.bucket_totals"><span>Past due</span><b>{{ run.bucket_totals.past_due | currency }}</b></div>
				<div class="vsr-kpi" *ngIf="run.bucket_totals"><span>Current</span><b>{{ run.bucket_totals.current | currency }}</b></div>
				<div class="vsr-kpi" *ngIf="run.bucket_totals"><span>Future</span><b>{{ run.bucket_totals.future | currency }}</b></div>
				<div class="vsr-kpi" *ngIf="run.bucket_totals?.pre_cutover"
					matTooltip="Dated before this vendor's V8 cutover — in the statement total, out of amount due now. Still owed if the vendor is billing it: book once as an opening balance.">
					<span>Pre-cutover (carried)</span><b>{{ run.bucket_totals.pre_cutover | currency }}</b></div>
				<div class="vsr-kpi"><span>Lines</span><b>{{ run.total_lines }}</b></div>
			</div>
			<table class="vsr-table">
				<thead><tr><th>Issue</th><th>Action</th><th class="r">Count</th><th class="r">Amount</th></tr></thead>
				<tbody>
					<tr *ngFor="let i of issues" class="vsr-click" (click)="subTab='issues'; loadLines(i.issue)">
						<td>{{ issueLabels[i.issue] || i.issue }}</td>
						<td>{{ actionLabels[i.proposed_action] || i.proposed_action }}</td>
						<td class="r">{{ i.n }}</td>
						<td class="r">{{ i.amt | currency }}</td>
					</tr>
				</tbody>
			</table>

			<div class="vsr-card__title mt-3" *ngIf="fixes?.length">Applied fixes (audited)</div>
			<table class="vsr-table" *ngIf="fixes?.length">
				<thead><tr><th>Fix</th><th>supptrans</th><th>Before → After</th><th>Status</th><th></th></tr></thead>
				<tbody>
					<tr *ngFor="let fx of fixes">
						<td>{{ fx.fix_type }}</td><td>{{ fx.supptrans_id }}</td>
						<td class="small">{{ fx.before_json }} → {{ fx.after_json }}</td>
						<td>{{ fx.status }}</td>
						<td><button class="btn btn-sm btn-outline-secondary" *ngIf="fx.status==='applied'" (click)="rollback(fx)">Roll back</button></td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- ISSUES & ACTIONS -->
		<div class="vsr-card" *ngIf="subTab==='issues' || subTab==='raw'">
			<div class="vsr-filter" *ngIf="subTab==='issues'">
				<button class="vsr-chip" [class.is-active]="!activeIssue" (click)="loadLines(null)">All</button>
				<button class="vsr-chip" *ngFor="let i of issues" [class.is-active]="activeIssue===i.issue" (click)="loadLines(i.issue)">
					{{ issueLabels[i.issue] || i.issue }} ({{ i.n }})
				</button>
				<label class="vsr-toggle"><input type="checkbox" [(ngModel)]="showSuggestions"> Show match suggestions</label>
				<button class="btn btn-primary btn-sm" [disabled]="applying || selectedCount()===0" (click)="applySelectedFixes()"
					[matTooltip]="!activeIssue ? 'Pick a specific issue type above to bulk-apply — mixing risk levels in one batch is disabled' : ''">
					{{ applying ? 'Applying…' : (!activeIssue ? 'Pick an issue type to bulk-apply' : (selectableLines().length===0 ? 'No auto-fixes in this section' : ('Apply selected fixes (' + selectedCount() + ')'))) }}
				</button>
			</div>
			<div class="vsr-scroll" [class.vsr-loading-host]="loadingLines">
				<div class="vsr-loading-overlay" *ngIf="loadingLines"><span class="vsr-spinner"></span> Loading rows…</div>
				<table class="vsr-table">
					<thead><tr>
						<th *ngIf="subTab==='issues'">
							<input *ngIf="selectableLines().length>0" type="checkbox" [checked]="allSelectableSelected()" [disabled]="applying" (change)="toggleAllSelectable($event)">
							<span *ngIf="selectableLines().length===0" class="vsr-select-na">—</span>
						</th>
						<th>Invoice</th><th>Doc</th><th>Stmt due</th><th>V8 due</th><th class="r">Stmt amt</th>
						<th>V8 ID</th><th>V8 trans#</th><th>V8 ref</th><th class="r">V8 gross</th><th class="r">V8 alloc</th><th class="r">V8 bal</th>
						<th *ngIf="showSuggestions">Closest V8 (verify — not a match)</th>
						<th>Issue</th><th>Action</th>
					</tr></thead>
					<tbody>
						<tr *ngFor="let l of lines" [class.vsr-row--issue]="l.issue!=='clean'">
							<td *ngIf="subTab==='issues'">
								<input *ngIf="activeIssue && canApply(l) && !isResolved(l)" type="checkbox" [checked]="isLineSelected(l)" [disabled]="applying" (change)="setLineSelected(l, $event)">
								<span *ngIf="!isResolved(l) && (!activeIssue || !canApply(l))" class="vsr-select-na" [matTooltip]="(!activeIssue && canApply(l)) ? 'Filter to this issue type to bulk-select' : ''">—</span>
								<span *ngIf="isResolved(l)" class="vsr-done">✓</span>
							</td>
							<td [class.vsr-cell--bad]="highlightCell(l, 'invoice')">{{ l.stmt_invoice }}</td>
							<td>{{ l.doc_date }}</td>
							<td [class.vsr-cell--bad]="highlightCell(l, 'stmt_due')">{{ l.due_date }}</td>
							<td [class.vsr-cell--bad]="highlightCell(l, 'v8_due')">{{ l.erp_due_date || '—' }}</td>
							<td class="r" [class.vsr-cell--bad]="highlightCell(l, 'stmt_amt')">{{ l.amount | number:'1.2-2' }}</td>
							<td [class.vsr-cell--bad]="highlightCell(l, 'v8_id')">{{ l.erp_supptrans_id || '—' }}</td>
							<td [class.vsr-cell--bad]="highlightCell(l, 'v8_id')">{{ l.erp_transno || '—' }}</td>
							<td [class.vsr-cell--bad]="highlightCell(l, 'v8_ref')">{{ l.erp_ref || '—' }}</td>
							<td class="r" [class.vsr-cell--bad]="highlightCell(l, 'v8_gross')">{{ l.erp_gross==null ? '—' : (l.erp_gross | number:'1.2-2') }}</td>
							<td class="r" [class.vsr-cell--bad]="highlightCell(l, 'v8_alloc')">{{ l.erp_alloc==null ? '—' : (l.erp_alloc | number:'1.2-2') }}</td>
							<td class="r" [class.vsr-cell--bad]="highlightCell(l, 'v8_bal')">{{ l.erp_balance==null ? '—' : (l.erp_balance | number:'1.2-2') }}</td>
							<td *ngIf="showSuggestions" class="small">
								<ng-container *ngIf="hasSuggestion(l)">
									<span class="vsr-conf" [class.vsr-conf--typo]="detail(l).confidence==='likely_typo'">{{ confLabels[detail(l).confidence] }}</span>
									{{ detail(l).suggest_ref }} <span class="vsr-reason">— {{ detail(l).reason }}</span>
								</ng-container>
							</td>
							<td>
								{{ issueLabels[l.issue] || l.issue }}
								<span class="vsr-also" *ngFor="let f of alsoFlags(l)" matTooltip="Also wrong on this row — fixing the issue above won't clear it">+ {{ f }}</span>
							</td>
							<td>
								<button class="btn btn-sm" [class.btn-warning]="l.proposed_action==='reopen_owner'" [class.btn-primary]="l.proposed_action!=='reopen_owner'"
									*ngIf="!isResolved(l) && canApply(l)" [disabled]="applying" (click)="applyFix(l)">
									{{ actionLabels[l.proposed_action] }}
								</button>
								<span *ngIf="!isResolved(l) && !canApply(l)">{{ actionLabels[l.proposed_action] || l.proposed_action }}</span>
								<span class="vsr-done" *ngIf="isResolved(l)">✓ {{ l.resolution }}</span>
								<button class="btn btn-sm btn-outline-danger ml-1" *ngIf="canReverse(l)" [disabled]="reversing"
									(click)="reverseLine(l)" matTooltip="Reverse the matched V8 row">
									Reverse
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- V8 PAYABLES (with matchback off the statement) -->
		<div class="vsr-card" *ngIf="subTab==='payables'">
			<div class="vsr-loading-line" *ngIf="loadingPayables">
				<span class="vsr-spinner"></span> Loading V8 payables…
			</div>
			<div class="vsr-matchback" *ngIf="matchback && matchback.review_count > 0">
				<b>{{ matchback.review_count }}</b> open V8 payable(s) due by the statement date are not on this statement
				({{ matchback.review_amount | currency }}). Review before payment.
			</div>
			<div class="vsr-filter" *ngIf="payablesReviewOnly && displayedPayables().length">
				<span>Verify each row, then select the ones that are our entry errors (dupes, mis-postings) and reverse them —
					whatever's left unchecked is the genuine set to work out with the owner/Ray.</span>
				<button class="btn btn-outline-danger btn-sm ml-2" [disabled]="bulkReversing || reversing || reviewSelectedCount()===0" (click)="bulkReverseSelected()">
					{{ bulkReversing ? 'Reversing…' : ('Reverse selected (' + reviewSelectedCount() + ')' + (reviewSelectedCount() ? ' — ' + (reviewSelectedTotal() | currency) : '')) }}
				</button>
			</div>
			<div class="vsr-scroll" [class.vsr-loading-host]="loadingPayables">
				<div class="vsr-loading-overlay" *ngIf="loadingPayables"><span class="vsr-spinner"></span> Loading payables…</div>
				<table class="vsr-table">
					<thead><tr>
						<th *ngIf="payablesReviewOnly">
							<input *ngIf="displayedPayables().length>0" type="checkbox" [checked]="allReviewSelected()" [disabled]="bulkReversing" (change)="toggleAllReview($event)">
						</th>
						<th>V8 ID</th><th>V8 trans#</th><th>Payment/check</th><th>Type</th><th>Date</th><th>Due</th><th>Terms</th><th>Reference</th><th class="r">Total</th><th class="r">Applied</th><th class="r">Balance</th><th>Settled</th><th>On statement?</th>
						<th *ngIf="payablesReviewOnly"></th>
					</tr></thead>
					<tbody>
						<tr *ngFor="let p of displayedPayables()" [class.vsr-row--review]="p.review==1">
							<td *ngIf="payablesReviewOnly">
								<input type="checkbox" [checked]="isReviewSelected(p)" [disabled]="bulkReversing || reversing" (change)="setReviewSelected(p, $event)">
							</td>
							<td [class.vsr-cell--bad]="p.review==1">{{ p.id }}</td><td [class.vsr-cell--bad]="p.review==1">{{ p.transno }}</td><td>{{ p.checknum || '—' }}</td><td>{{ p.typename }}</td><td>{{ p.trandate }}</td><td [class.vsr-cell--bad]="p.review==1">{{ p.duedate }}</td>
							<td>{{ p.paymentterms }}</td><td>{{ p.suppreference }}</td>
							<td class="r">{{ p.total | number:'1.2-2' }}</td><td class="r">{{ p.applied | number:'1.2-2' }}</td>
							<td class="r" [class.vsr-cell--bad]="p.review==1">{{ p.balance | number:'1.2-2' }}</td><td>{{ p.settled }}</td>
							<td [class.vsr-cell--bad]="p.review==1"><span [class.vsr-no]="p.on_statement==='No'">{{ p.on_statement }}</span><span *ngIf="p.review==1" class="vsr-flag"> review</span></td>
							<td *ngIf="payablesReviewOnly">
								<button class="btn btn-sm btn-outline-danger" [disabled]="bulkReversing || reversing" (click)="reversePayable(p)" matTooltip="Reverse this V8 row">Reverse</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- READY TO PAY: open + on this statement -> pending payment run -->
		<div class="vsr-card" *ngIf="subTab==='ready'">
			<div class="vsr-loading-line" *ngIf="loadingPayables">
				<span class="vsr-spinner"></span> Loading payables…
			</div>

			<div class="vsr-paybar">
				<span class="vsr-paybar__count" [class.is-on]="paySelectedRows().length">
					{{ paySelectedRows().length }} of {{ readyRows().length }} selected · {{ paySelectedTotal() | currency }}
				</span>
				<label>Due by <input type="date" [(ngModel)]="payDueCutoff" title="Only show items due on/before this date — clear to show everything on the statement"></label>
				<label>Bank
					<select [(ngModel)]="payBankAcct">
						<option value="">— choose —</option>
						<option *ngFor="let b of bankAccounts" [value]="b.accountcode">{{ b.bankaccountname }}</option>
					</select>
				</label>
				<label>Payment type
					<select [(ngModel)]="payPaymentType">
						<option *ngFor="let m of paymentMethods" [value]="m.paymentname">{{ m.paymentname }}</option>
					</select>
				</label>
				<label>Pay date <input type="date" [(ngModel)]="payDate"></label>
				<label>Check # <input type="text" class="vsr-paybar__chk" [(ngModel)]="payCheckNum"></label>
				<button class="btn btn-primary btn-sm" [disabled]="generatingRun || !paySelectedRows().length" (click)="generatePaymentRun()">
					{{ generatingRun ? 'Creating…' : 'Generate payment run' }}
				</button>
			</div>

			<div class="vsr-scroll" [class.vsr-loading-host]="loadingPayables">
				<div class="vsr-loading-overlay" *ngIf="loadingPayables"><span class="vsr-spinner"></span> Loading payables…</div>
				<table class="vsr-table">
					<thead><tr>
						<th><input type="checkbox" *ngIf="readyRows().length" [checked]="allReadySelected()" [disabled]="generatingRun" (change)="toggleAllReady($event)"></th>
						<th>V8 ID</th><th>V8 trans#</th><th>Type</th><th>Date</th><th>Due</th><th>Terms</th><th>Reference</th><th class="r">Total</th><th class="r">Applied</th><th class="r">Balance</th>
					</tr></thead>
					<tbody>
						<tr *ngFor="let p of readyRows()">
							<td><input type="checkbox" [checked]="isPaySelected(p)" [disabled]="generatingRun" (change)="setPaySelected(p, $event)"></td>
							<td>{{ p.id }}</td><td>{{ p.transno }}</td><td>{{ p.typename }}</td><td>{{ p.trandate }}</td><td>{{ p.duedate }}</td>
							<td>{{ p.paymentterms }}</td><td>{{ p.suppreference }}</td>
							<td class="r">{{ p.total | number:'1.2-2' }}</td><td class="r">{{ p.applied | number:'1.2-2' }}</td>
							<td class="r" [class.neg]="p.balance < 0">{{ p.balance | number:'1.2-2' }}</td>
						</tr>
						<tr *ngIf="!loadingPayables && !readyRows().length" class="vsr-empty-row">
							<td colspan="11">Nothing open on this statement{{ payDueCutoff ? ' due by ' + payDueCutoff : '' }} — clear the Due by filter or check V8 Payables.</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</ng-container>

	<div class="vsr-empty" *ngIf="!run && !loadingRun && !loadingRuns">Upload a statement and run reconciliation, or pick a recent run above.</div>
	<div class="vsr-empty" *ngIf="!run && (loadingRun || loadingRuns)"><span class="vsr-spinner"></span> Loading reconciliation history…</div>
</div>
